var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.71875 13.4375C3.01375 13.4375 0 10.4237 0 6.71875C0 3.01375 3.01375 0 6.71875 0C10.4237 0 13.4375 3.01375 13.4375 6.71875C13.4375 10.4237 10.4237 13.4375 6.71875 13.4375ZM6.71875 0.9375C3.53063 0.9375 0.9375 3.53063 0.9375 6.71875C0.9375 9.90687 3.53063 12.5 6.71875 12.5C9.90687 12.5 12.5 9.90687 12.5 6.71875C12.5 3.53063 9.90687 0.9375 6.71875 0.9375ZM7.35626 8.90625C7.35626 8.56125 7.07689 8.28125 6.73126 8.28125H6.72501C6.38001 8.28125 6.10306 8.56125 6.10306 8.90625C6.10306 9.25125 6.38626 9.53125 6.73126 9.53125C7.07626 9.53125 7.35626 9.25125 7.35626 8.90625ZM7.1875 6.76315V3.90625C7.1875 3.6475 6.9775 3.4375 6.71875 3.4375C6.46 3.4375 6.25 3.6475 6.25 3.90625V6.76315C6.25 7.0219 6.46 7.2319 6.71875 7.2319C6.9775 7.2319 7.1875 7.0219 7.1875 6.76315Z",
    fill: "#FF6C22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.39ad05ded8e729646672d17c24a4e92b.svg";
export { ForwardRef as ReactComponent };